import { Component, OnInit } from '@angular/core';

import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UniquePipe } from '../vdms_shared/pipes/unique';

import {
  GlobalAppConstants,
  RadioOption,
  DropDown,
} from '../vdms_shared/constant/app.constant';
import { VehicleService } from '../vdms_core/services/api/vehicle.service';
import { VendorModel } from '../vdms_core/model/vendor.modal';
import { AwsS3BucketService } from '../vdms_core/services/awsS3Bucket/aws-s3-bucket.service';
import { VendorService } from '../vdms_core/services/api/vendor.service';
import { Router } from '@angular/router';
import { DataService } from '../vdms_core/services/vehicle/vehicle.data.services';

// Custom validator function for chassis number
export function chassisNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Check if the value is defined and exactly 16 characters long
    if (!value || value.length !== 17) {
      return { invalidChassisNumber: true }; // Handle invalid length
    }

    // Check if the value contains only alphanumeric characters
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(value); // Check for only alphanumeric characters

    // Check for at least one letter and one number
    const hasLetter = /[a-zA-Z]/.test(value); // Check for at least one letter
    const hasNumber = /[0-9]/.test(value); // Check for at least one number

    // Return error if it fails any of the conditions
    if (!isAlphanumeric || !hasLetter || !hasNumber) {
      return { invalidChassisNumber: true }; // Return an error object
    }

    return null; // Return null if validation passes
  };
}

@Component({
  selector: 'app-add-vehicle',
  // standalone: true,
  // imports: [ReactiveFormsModule, CommonModule, UniquePipe],
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.css'],
})
export class AddVehicleComponent implements OnInit {
  vehicleForm: FormGroup;
  getVendorOptionsData: any = [];
  vendorOptions: any = [];
  vehicleBrandOptions: DropDown[];
  fuelTypeOptions: RadioOption[];
  vehicleTypeOptions: RadioOption[];
  vehicleModelOptions: DropDown[];

  filesUploadArray: Array<any> = [];
  awsImagePath: any;
  imageProgressBar: any;

  docInsuranceObj: any;
  docRcBookObj: any;
  docLeaseObj: any;

  searchObj: any;

  isEditModeStatus: boolean = false;
  isViewModeStatus: boolean = false
  isSurrenderModeStatus: boolean = false

  pageSize: number = 2;
  // pageIndex: number = 0;
  activePage: number = 0;
  //noOfItems = 10;

  vehicles = [ // Sample vehicle data
    { id: 1, name: 'Car 1' },
    { id: 2, name: 'Car 2' },
    { id: 3, name: 'Car 3' },
    { id: 4, name: 'Car 4' },
    { id: 5, name: 'Car 5' },
    { id: 6, name: 'Car 6' },
    { id: 7, name: 'Car 7' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private vehicleService: VehicleService,
    private awsS3BucketService: AwsS3BucketService,
    private vendorService: VendorService,
    private router: Router,
    public dataService: DataService
  ) {
    this.getVendorOptions();
    this.optionInitialization();
  }

  public optionInitialization() {
    this.vehicleBrandOptions = GlobalAppConstants.vehicleBrand;
    this.fuelTypeOptions = GlobalAppConstants.fuelTypeArray;
    this.vehicleTypeOptions = GlobalAppConstants.vehicleType;
  }


  // checkInit() {
  //   const existingData = this.dataService.getRecord();

  //   // Ensure existingData is not null or undefined before proceeding
  //   if (existingData && (existingData['isSurrenderMode'] !== undefined || existingData['isViewMode'] !== undefined)) {
  //     this.isActiveSurrenderMode = existingData['isSurrenderMode'];
  //     this.isViewMode = existingData['isViewMode'];

  //     // If in surrender mode or view mode, edit form and disable vehicle form
  //     this.editForm(existingData);
  //     this.vehicleForm.disable();
  //   } else {
  //     // If existingData is null/undefined or does not have relevant keys, proceed accordingly
  //     if (existingData && Object.keys(existingData).length > 0) {
  //       console.log('Edit_mode');
  //       this.isEditMode = true;
  //       this.editForm(existingData);
  //     } else {
  //       console.log('Create_mode');
  //       this.initializeForm();
  //     }
  //   }


  //   this.dataService.clearRecord();
  // }


  // Initialize or patch form based on mode
  checkInit() {
    const existingData = this.dataService.getRecord();

    if (existingData) {
      const mode = existingData.mode;
      switch (mode) {
        case 'isEditMode':
          this.isEditModeStatus = true;
          this.editForm(existingData);
          break;
        case 'isViewMode':
          this.isViewModeStatus = true;
          this.editForm(existingData);
          this.vehicleForm.disable(); // Disable form for view mode
          break;
        case 'isSurrenderMode':
          this.isSurrenderModeStatus = true;
          this.editForm(existingData);
          //  this.vehicleForm.disable(); // Disable form for surrender mode
          break;
        default:
          this.initializeForm(); // Create mode
      }
    } else {
      this.initializeForm(); // Create mode if no data found
    }

    this.dataService.clearRecord();
  }

  ngOnInit(): void {
    // Receive the data from the parent component via history.state
    // const existingData = history?.state?.record;

    // const existingData = history && history.state && history.state.record;

    // const existingData = this.dataService.getRecord();


    // // Ensure existingData is not null or undefined before proceeding
    // if (existingData && (existingData['isSurrenderMode'] !== undefined || existingData['isViewMode'] !== undefined)) {
    //   this.isActiveSurrenderMode = existingData['isSurrenderMode'];
    //   this.isViewMode = existingData['isViewMode'];

    //   // If in surrender mode or view mode, edit form and disable vehicle form
    //   this.editForm(existingData);
    //   this.vehicleForm.disable();
    // } else {
    //   // If existingData is null/undefined or does not have relevant keys, proceed accordingly
    //   if (existingData && Object.keys(existingData).length > 0) {
    //     console.log('Edit_mode');
    //     this.isEditMode = true;
    //     this.editForm(existingData);
    //   } else {
    //     console.log('Create_mode');
    //     this.initializeForm();
    //   }
    // }


    // this.dataService.clearRecord();
    // alert(Object.keys(existingData).length)
    // if (Object.keys(existingData).length == 0) {
    //   console.log('Create_mode');
    //   this.initializeForm();
    // } else {
    //   //alert(existingData)
    //   console.log('existingData:', existingData);
    //   this.isActiveSurrenderMode = existingData['isSurrenderMode']
    //   this.isViewMode = existingData['isViewMode']
    //   if (this.isActiveSurrenderMode) {
    //     this.editForm(existingData);
    //     this.vehicleForm.disable();
    //   } else if (this.isViewMode) {
    //     this.editForm(existingData);
    //     this.vehicleForm.disable();

    //   } else {
    //     // Check if existingData is valid and has at least one key
    //     if (existingData && Object.keys(existingData).length > 0) {
    //       console.log('Edit_mode');
    //       this.isEditMode = true;
    //       this.editForm(existingData);
    //     } else {
    //       console.log('Create_mode');
    //       this.initializeForm();
    //     }
    //   }
    // }
    // //alert(existingData)
    // console.log('existingData:', existingData);
    // this.isActiveSurrenderMode = existingData['isSurrenderMode']
    // this.isViewMode = existingData['isViewMode']
    // if (this.isActiveSurrenderMode) {
    //   this.editForm(existingData);
    //   this.vehicleForm.disable();
    // } else if (this.isViewMode) {
    //   this.editForm(existingData);
    //   this.vehicleForm.disable();

    // } else {
    //   // Check if existingData is valid and has at least one key
    //   if (existingData && Object.keys(existingData).length > 0) {
    //     console.log('Edit_mode');
    //     this.isEditMode = true;
    //     this.editForm(existingData);
    //   } else {
    //     console.log('Create_mode');
    //     this.initializeForm();
    //   }
    // }

    // // Check if existingData is valid and has at least one key
    // if (existingData && Object.keys(existingData).length > 0) {
    //   console.log('Edit_mode');
    //   this.isEditMode = true;
    //   this.editForm(existingData);
    // } else {
    //   console.log('Create_mode');
    //   this.initializeForm();
    // }
  }


  initializeForm(): void {
    this.vehicleForm = this.formBuilder.group({
      agency_name: ['', [Validators.required]],
      veh_reg_id: ['', [Validators.required]],
      car_make: ['', [Validators.required]],
      car_model: ['', [Validators.required]],
      car_variant: ['', [Validators.required]],
      car_color: ['', [Validators.required]],
      fuel_type: ['', [Validators.required]],
      car_type: ['', [Validators.required]],
      chasis_number: [
        '',
        [
          Validators.required,
          chassisNumberValidator()
        ],
      ],
      po_number: [''],
      asset_number: [''],
      rental_month: [''],
      document_code: [''],
      car_registration_date: [''],
      vehicle_rc_book_attachments: this.formBuilder.array([]),
      policy_no: [''],
      policy_from: [''],
      policy_to: [''],
      insurance_policy_attachments: this.formBuilder.array([]),
      lease_from: [''],
      lease_to: [''],
      vehicle_lease_attachments: this.formBuilder.array([]),
      surrender_date: ['', []],
      surrender_car_attachments: this.formBuilder.array([]),
    });

    // Set selected flags based on existing data
    this.resetSelectedOptions(this.vehicleTypeOptions);
    this.resetSelectedOptions(this.fuelTypeOptions);
    // Listen to surrender control changes
    this.onSurrenderChange(false);

  }

  // Method to reset selected flags for create mode
  resetSelectedOptions(options: { value: string; label: string; selected: boolean }[]) {
    options.forEach(option => {
      option.selected = false;  // Ensure all are deselected
    });
  }

  // Method to dynamically manage fields based on surrender status
  onSurrenderChange(surrender) {
    // this.vehicleForm.get('surrender').valueChanges.subscribe((surrender) => {
    const surrenderDate = this.vehicleForm.get('surrender_date');
    const surrenderCarAttachments = this.vehicleForm.get('surrender_car_attachments');

    if (surrender) {
      // Add validators for surrender fields if surrender is triggered
      surrenderDate.setValidators([Validators.required]);
      surrenderCarAttachments.setValidators([Validators.required]);
    } else {
      // Remove validators and reset surrender fields if not surrendering
      surrenderDate.clearValidators();
      surrenderDate.reset();
      surrenderCarAttachments.clearValidators();
      surrenderCarAttachments.reset();
    }

    // Update validation status of the form
    surrenderDate.updateValueAndValidity();
    surrenderCarAttachments.updateValueAndValidity();
    // });
  }

  uploadOptions(url: string): FormGroup {
    return this.formBuilder.group({
      url: [url, [Validators.required]],
      uploaded_on: [new Date().toISOString(), [Validators.required]],
    });
  }

  get vehicleRcBookAttachments(): FormArray {
    return this.vehicleForm.get('vehicle_rc_book_attachments') as FormArray;
  }

  get insurancePolicyAttachments(): FormArray {
    return this.vehicleForm.get('insurance_policy_attachments') as FormArray;
  }

  get vehicleLeaseAttachments(): FormArray {
    return this.vehicleForm.get('vehicle_lease_attachments') as FormArray;
  }

  get surrenderCarAttachments(): FormArray {
    return this.vehicleForm.get('surrender_car_attachments') as FormArray;
  }

  editForm(existingDataBinding: any): void {
    this.vehicleForm = this.formBuilder.group({
      id: [existingDataBinding.id, [Validators.required]],// new FormControl(existingDataBinding.id),
      agency_name: [existingDataBinding.agency_name, [Validators.required]],
      veh_reg_id: [existingDataBinding.veh_reg_id, [Validators.required]],
      car_make: [existingDataBinding.car_make, [Validators.required]],
      car_variant: [existingDataBinding.car_variant, [Validators.required]],
      car_model: [existingDataBinding.car_model, [Validators.required]],
      car_color: [existingDataBinding.car_color, [Validators.required]],
      fuel_type: [existingDataBinding.fuel_type, [Validators.required]],
      car_type: [existingDataBinding.car_type, [Validators.required]],
      chasis_number: [
        existingDataBinding.chasis_number,
        [
          Validators.required,
          chassisNumberValidator()
        ],
      ],
      po_number: [existingDataBinding.po_number],
      asset_number: [existingDataBinding.asset_number],
      rental_month: [existingDataBinding.rental_month],
      document_code: [existingDataBinding.document_code],
      car_registration_date: [
        existingDataBinding.car_registration_date

      ],
      vehicle_rc_book_attachments: this.formBuilder.array([]),
      policy_no: [existingDataBinding.policy_no],
      policy_from: [existingDataBinding.policy_from],
      policy_to: [existingDataBinding.policy_to],
      insurance_policy_attachments: this.formBuilder.array([]),
      lease_from: [existingDataBinding.lease_from],
      lease_to: [existingDataBinding.lease_to],
      vehicle_lease_attachments: this.formBuilder.array([]),
      surrender_date: [existingDataBinding.surrender_date, []],
      surrender_car_attachments: this.formBuilder.array([]),
    });


    // Set selected flags based on existing data
    this.setSelectedOptions(this.fuelTypeOptions, existingDataBinding.fuel_type);
    this.setSelectedOptions(this.vehicleTypeOptions, existingDataBinding.car_type);



    this.setVehicleRcBookAttachments(
      existingDataBinding.vehicle_rc_book_attachments
    );
    this.setInsurancePolicyAttachments(
      existingDataBinding.insurance_policy_attachments
    );
    this.setVehicleLeaseAttachments(
      existingDataBinding.vehicle_lease_attachments
    );

    this.setVehicleSurrenderAttachments(
      existingDataBinding.surrender_car_attachments
    );
  }

  // Method to set selected flags for options
  setSelectedOptions(options: { value: string; label: string; selected: boolean }[], selectedValue: string) {
    options.forEach(option => {
      option.selected = option.value === selectedValue.toLowerCase();
    });
  }

  // Method to set upload options for vehicleRcBookAttachments
  setVehicleRcBookAttachments(data: { url: string; uploaded_on: string }[]) {
    console.log('RC_book', data);
    if (!data) {
      return;
    }

    const attachmentsArray = this.vehicleRcBookAttachments;
    //attachmentsArray.clear(); // Clear existing values

    // Remove all controls from the FormArray
    while (attachmentsArray.length !== 0) {
      attachmentsArray.removeAt(0);
    }


    data.forEach((item) => {
      console.log('PRINT::', item.url, item.uploaded_on);
      attachmentsArray.push(
        this.patchUploadOptions(item.url, item.uploaded_on)
      );

    });


  }

  // Method to set upload options for insurancePolicyAttachments
  setInsurancePolicyAttachments(data: { url: string; uploaded_on: string }[]) {
    if (!data) {
      return;
    }

    const attachmentsArray = this.insurancePolicyAttachments;
    // attachmentsArray.clear(); // Clear existing values

    data.forEach((item) => {
      attachmentsArray.push(
        this.patchUploadOptions(item.url, item.uploaded_on)
      );
      // this.rcDownload(item.url)
    });
  }

  // Method to set upload options for vehicleLeaseAttachments
  setVehicleLeaseAttachments(data: { url: string; uploaded_on: string }[]) {
    if (!data) {
      return;
    }

    const attachmentsArray = this.vehicleLeaseAttachments;
    // attachmentsArray.clear(); // Clear existing values

    data.forEach((item) => {
      attachmentsArray.push(
        this.patchUploadOptions(item.url, item.uploaded_on)
      );
    });
  }

  // Method to set upload options for vehicleSurrenderAttachments
  setVehicleSurrenderAttachments(data: { url: string; uploaded_on: string }[]) {
    if (!data) {
      return;
    }

    const attachmentsArray = this.surrenderCarAttachments;
    // attachmentsArray.clear(); // Clear existing values

    data.forEach((item) => {
      attachmentsArray.push(
        this.patchUploadOptions(item.url, item.uploaded_on)
      );
    });
  }
  // setUploadOptions(data: any) {
  //   const arr: any = [];
  //   if (!data) {
  //     return arr;
  //   }
  //   for (let i = 0; i < data.length; i++) {
  //     arr.push(this.patchUploadOptions(data[i].url, data[i].uploaded_on));
  //   }
  //   return arr;
  // }

  // Method to create a FormGroup for upload options
  patchUploadOptions(url: string, uploaded_on: string): FormGroup {
    return this.formBuilder.group({
      url: [url],
      uploaded_on: [uploaded_on],
    });
  }

  get f() {
    return this.vehicleForm.controls;
  }

  // get chasisNumber() {
  //   return this.vehicleForm.get('chasis_number');
  // }

  /**************************************************************************************
   * REACTIVE FORM IMAGE PREVIEW FUNCTIONALITIES
   **************************************************************************************/

  onFileChange(event: any, namePrefix: string) {
    const files: FileList = event.target.files;

    if (files.length > 0) {
      const file: File = files[0];
      for (let i = 0; i < files.length; i++) {
        // this.filesUploadArray.push(files[i]);
        this.filesUploadArray.push(this.renamedFileName(files[i], namePrefix));
      }
      console.log('filesUploadArray', this.filesUploadArray);
    }
  }

  removeFile(index: number) {
    this.filesUploadArray.splice(index, 1);
    console.log('REMOVE_index', this.filesUploadArray);
  }

  renamedFileName(file: File, namePrefix: string) {
    const vehicleNumber = this.vehicleForm.get('veh_reg_id').value;
    const timestamp = new Date().getTime(); // Get current Unix timestamp
    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts.pop(); // Extract the file extension
    const originalFileNameWithoutExtension = fileNameParts.join('.'); // Join the remaining parts to get the original file name without extension
    const renamedFileName = `${namePrefix}_${vehicleNumber}_${timestamp}.${fileExtension}`; // Append timestamp and original file extension to the file name
    const renamedFile = new File([file], renamedFileName, { type: file.type });
    return renamedFile;
  }

  // Method to handle input and remove spaces
  removeSpaces(event: any, controlName: string) {
    const value = event.target.value;
    const newValue = value.replace(/\s/g, ''); // Remove spaces
    this.vehicleForm.get(controlName).setValue(newValue); // Update form control value
  }

  // noWhitespaceValidator(): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //     if (control.value && /\s/.test(control.value)) {
  //       return { noWhitespace: true }; // Error if value contains whitespace
  //     }
  //     return null;
  //   };
  // }
  // noWhitespaceValidator(): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //     if (control.value && control.value.trim().length === 0) {
  //       return { noWhitespace: true }; // Error if value contains only whitespace
  //     }
  //     return null;
  //   };
  // }


  // alphanumericWithLettersAndNumbers(): ValidatorFn {

  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const value = control.value;
  //     if (!value) {
  //       return null; // If the value is empty, don't show an error
  //     }

  //     const hasLetters = /[a-zA-Z]/.test(value); // Check if the value contains letters
  //     const hasNumbers = /[0-9]/.test(value); // Check if the value contains numbers

  //     if (!hasLetters || !hasNumbers) {
  //       return { alphanumeric: true }; // Return an error if the value doesn't contain both letters and numbers
  //     }

  //     return null; // If the value contains both letters and numbers, no error
  //   };
  // }

  handleRadioChange(event: Event, control: string, option: RadioOption): void {
    console.log('Control:', control);
    if (control !== null) {
      // Access the form control using control name
      const formControl: any = this.vehicleForm.get(control);

      // Update the form control value with the selected option's value
      formControl.setValue(option.value);
    }
  }

  handleSelectChange(event: Event, control: string): void {
    // Access the form control using control name
    const formControl: any = this.vehicleForm.get(control);

    // Update the form control value with the selected option's value
    formControl.setValue((event.target as HTMLSelectElement).value);

    // Call setModelDropdown only if the control is 'car_make'
    if (control === 'car_make') {
      this.setModelDropdown(
        (event.target as HTMLSelectElement).value.toLowerCase()
      );
    }
  }

  setModelDropdown(control: string): void {
    console.log('setModelDropdown', control);
    switch (control) {
      case 'renault':
        this.vehicleModelOptions = GlobalAppConstants.renaultBrand;
        break;

      case 'nissan':
        this.vehicleModelOptions = GlobalAppConstants.nissanBrand;
        break;

      default:
        // Reset car_model dropdown to its initial state
        // this.vehicleForm.get('car_model')?.reset();
        break;
    }
  }

  // handleRadioChange(
  //   control: VehicleFormControlConfig | undefined,
  //   selectedOption: RadioOption
  // ): void {
  //   if (control && control.radioOptions) {
  //     control.radioOptions.forEach(
  //       (option) => (option.selected = option === selectedOption)
  //     );
  //     if (control.name !== null) {
  //       const formControl = this.vehicleForm.get(control.name);
  //       if (formControl) {
  //         formControl.setValue(selectedOption.value);
  //       }
  //     }
  //   }
  // }

  // handleCheckboxChange(
  //   control: VehicleFormControlConfig,
  //   selectedOption: CheckboxOption
  // ): void {
  //   selectedOption.selected = !selectedOption.selected;
  //   // If needed, you can collect all selected checkbox values into an array
  // }

  async getVendorOptions() {
    const vendorDetails = await this.vendorService.filterByVendor('Car');
    if (vendorDetails) {
      this.getVendorOptionsData = vendorDetails.items; // Populate the select options
      // this.setInitialVendor(); // Set the selected vendor after data is available

      if (this.getVendorOptionsData.length > 0) {

        this.checkInit();
      }

    }
  }

  // async getVendorDetails() {
  //   this.vendorOptions = await this.vendorService.filterByVendor('Car')
  //   console.log('vendor_LIST', this.vendorOptions.items)
  //   // if (vendorDetails && Object.keys(vendorDetails).length > 0) {
  //   //  // alert(vendorDetails[0].name);
  //   //    = vendorDetails;
  //   // }

  //   //alert(vendorDetails.items[0].name)
  //   this.checkInit();
  //   console.log('VENODR_DROP_', this.vendorOptions);
  // }


  ngAfterViewInit() {
    // This will update the selected vendor after the view has initialized
    this.setInitialVendor();
  }

  setInitialVendor() {
    // Set the initial selected vendor value (you can choose the logic here)
    if (this.getVendorOptionsData && this.getVendorOptionsData.length > 0) {
      this.vendorOptions = this.getVendorOptionsData  // Auto-select first vendor
    }
  }

  async uploadFilesSimulator(): Promise<any> {
    var selectedFileObj;
    var urlPath: any;
    var inx: any;
    let result: any;
    if (!this.filesUploadArray.length) {
      // console.log('CHECK_MODE_1', this.isEditMode);
      if (this.isEditModeStatus) {
        console.log('Update_vehicle', this.isEditModeStatus);
        this.OnUpdateVehicle();
        return;
      } else if (this.isSurrenderModeStatus) {
        console.log('Surrender_vehicle', this.isSurrenderModeStatus);
        this.OnSurrenderVehicle();
        return;
      }
      else {
        console.log('save_vehicle', this.isEditModeStatus);
        this.OnSaveVehicle();
        return;
      }
    }
    this.filesUploadArray.forEach((file, index) => {
      inx = index;
      selectedFileObj = file;

      const fileNameParts = file.name.split('_');
      console.log('fileNameParts', fileNameParts);
      const folderName = fileNameParts[0]; // Extract the folder name from the file name
      console.log('folderName', folderName);
      // const awsImagePath
      urlPath = `vdms/${folderName}/${file.name}`;

      console.log('awsImagePath', urlPath);

      // if (obj.type.includes('image')) {
      //   selectedFileObj = obj;
      //   inx = index;
      //   this.awsImagePath = 'vdms/' + selectedFileObj.name;

      //   this.awsS3BucketService.getObserver().subscribe((progress) => {
      //     this.imageProgressBar = progress;
      //   });
      // }
    });

    if (this.filesUploadArray.length > 0) {
      try {
        result = await this.awsS3BucketService
          .uploadFile(selectedFileObj, urlPath)
          .then((res) => {
            console.log('Upload_success', res);

            console.log('get_key', res.Key);

            // this.findFolderPreSignedURL(res);

            const urlNameParts = res.Key.split('/');
            console.log('urlNameParts', urlNameParts);
            const folderName = urlNameParts[1]; // Extract the folder name from the url name
            console.log('URLName', folderName);

            var obj: any = {
              url: res.Key,
              uploaded_on: new Date().toISOString(),
            };

            if (folderName == 'insurance') {
              //this.docInsuranceObj = obj;
              this.insurancePolicyAttachments.push(this.uploadOptions(res.Key));
            }

            if (folderName == 'rcbook') {
              // this.docRcBookObj = obj;
              this.vehicleRcBookAttachments.push(this.uploadOptions(res.Key));
            }

            if (folderName == 'lease') {
              //this.docLeaseObj = obj;
              this.vehicleLeaseAttachments.push(this.uploadOptions(res.Key));
            }

            if (folderName == 'surrender') {
              //this.docLeaseObj = obj;
              this.surrenderCarAttachments.push(this.uploadOptions(res.Key));
            }
            // if (folderName == 'surrender' && this.isSurrenderModeStatus) {
            //   //this.docLeaseObj = obj;
            //   this.surrenderCarAttachments.push(this.uploadOptions(res.Key));
            // }

            //  const index = this.filesUploadArray.indexOf(file);
            this.filesUploadArray.splice(inx, 1);
            this.uploadFilesSimulator();
            // this.filesUploadArray.splice(inx, 1);
            // this.uploadFilesSimulator();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }


  // async onSearchVehicle() {
  //   const searchValue = this.vehicleForm.value;

  //   console.log('Search_value', searchValue.search);
  //   this.searchObj = '';

  //   this.searchObj = await this.vehicleService.filterByVehicleRegistration(
  //     searchValue.vehicleSearch
  //   );
  //   console.log('SEARCH_Vehicle', this.searchObj);
  //   const vehid = this.searchObj.items[0].veh_reg_id;
  //   console.log('check_veg', vehid);
  //   this.vehicleForm.get('veh_reg_id').setValue(vehid);

  //   this.vehicleForm.updateValueAndValidity();
  // }

  OnUpdateVehicle() {
    console.log('ON_UPDATE_VEHICLE');
    const value = this.vehicleForm.value;
    console.log('ON_UPDATE_VEHICLE', value);
    // console.log('EDIT_Value');
    this.vehicleService.updateVehicleMaster(value);
    //clear history state
    history.replaceState(null, '');
    this.navigate();
  }

  OnSaveVehicle() {
    console.log('ON_SAVE_VEHICLE');
    const value = this.vehicleForm.value;
    this.vehicleService.createVehicleMaster(value);
    this.navigate();
  }

  OnSurrenderVehicle() {
    console.log('ON_SAVE_VEHICLE');
    const value = this.vehicleForm.value;
    value["ex_data"] = 'SURRENDER';
    this.vehicleService.updateVehicleMaster(value);
    this.navigate();
  }

  navigate() {
    this.router.navigate(['/pages/vdms']);
  }


  rcDownload() {
    const paramURL = this.vehicleForm.get('vehicle_rc_book_attachments').value;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      //  this.generatePreSignedUrl(url)
      this.download(paramURL)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  insuranceDownload() {
    const paramURL = this.vehicleForm.get('insurance_policy_attachments').value;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  leaseDownload() {
    const paramURL = this.vehicleForm.get('vehicle_lease_attachments').value;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }


  surrenderDownload() {
    const paramURL = this.vehicleForm.get('surrender_car_attachments').value;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  private generatePreSignedUrl(key: string) {
    const params = {
      Bucket: 'rnconnect-ope',
      Key: key,
      Expires: 3600, // Set the expiration time in seconds (e.g., 1 hour)
    };
    const url = this.awsS3BucketService.getPreSignedUrl(key);
    console.log('presignedURL', url);

    this.downloadfile(url)

  }

  async download(data: any) {
    console.log('File_download', data);

    if (data !== null && data !== '') {
      if (data.length > 0) {
        // do something
        data.sort(function compare(a, b) {
          const dateA: any = new Date(a.uploaded_on);
          const dateB: any = new Date(b.uploaded_on);
          return dateB - dateA;
        });
        console.log('find_url', data[0])
        this.generatePreSignedUrl(data[0].url)
        // this.downloadAlertConfirm(key, data[0]);
      }
    } else {
      //this.errorAlertConfirm(key);
    }

    // if (data.length > 0) {
    //   data.sort(function compare(a, b) {
    //     const dateA: any = new Date(a.uploaded_on);
    //     const dateB: any = new Date(b.uploaded_on);
    //     return dateB - dateA;
    //   });

    //   this.downloadAlertConfirm(key, data[0]);
    // } else {
    //   this.errorAlertConfirm();
    // }

    console.log('::OUTPIT', data);
  }

  // // Option 1: Direct URL download
  downloadfile(result) {
    const link = document.createElement("a");
    link.setAttribute("href", result);
    link.setAttribute("download", result);
    // Set the target attribute to open in a new tab
    link.setAttribute("target", "_blank");

    document.body.appendChild(link);
    link.click();

    link.remove();
  }


  getFileNameFromUrl(url) {
    const regex = /\/([^\/?#]+)$/;
    const matches = url.match(regex);
    return matches ? matches[1] : null;
  }

  backToVdms() {
    this.router.navigate(["/pages/vdms"]);
  }

}
